module.exports = __webpack_public_path__ + "img/introduce.92dc94bb.png";